export enum CUSTOM_REPORT_NAME {
	EWA = 'ewa',
	EWA_D86 = 'ewa_d86',
	JDS_D86 = 'jds_d86',
	JDS_D92 = 'jds_d92'
}

export const JDS_D86_CURRENT_VERSION = '04/2025';
export const JDS_D86_CURRENT_REVISION = `JDS-D86 ${JDS_D86_CURRENT_VERSION}`;
